import { useEffect, useRef, useState, useCallback } from 'react'
import { useDocPreview } from 'hooks/useDocPreview'
import throttle from 'lodash/throttle'

export const usePDFLoading = ({ base64Data, mimeType }) => {
    const { setIsLoading, setLoadingProgress, isSidesPreview } = useDocPreview()
    const [documentWidth, setDocumentWidth] = useState(null)
    const [documentHeight, setDocumentHeight] = useState(null)
    const [numPages, setNumPages] = useState()
    const documentWrapperRef = useRef(null)

    const src = `data:${mimeType};base64,${base64Data}`

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages)
        setLoadingProgress(100)

        setTimeout(() => {
            setIsLoading(false)
        }, 500)
    }

    const onPageLoadSuccess = ({ _pageIndex }) => {
        if (isSidesPreview && _pageIndex === 1) {
            const pageElement = document.getElementsByClassName('react-pdf__page')?.[0]
            const height = pageElement?.clientHeight || null
            setDocumentHeight(height)
        }
    }

    const setPdfSize = useCallback(() => {
        if (documentWrapperRef?.current) {
            const wrapperWidth = documentWrapperRef.current.getBoundingClientRect().width
            setDocumentWidth(wrapperWidth > 750 ? 750 : wrapperWidth)
        }
    }, [documentWrapperRef])

    useEffect(() => {
        window.addEventListener('resize', throttle(setPdfSize, 1000))
        return () => {
            window.removeEventListener('resize', throttle(setPdfSize, 1000))
        }
    }, [setPdfSize])

    const setWrapperRef = (node) => {
        documentWrapperRef.current = node
        setPdfSize()
    }

    return { documentWidth, documentHeight, numPages, src, onDocumentLoadSuccess, onPageLoadSuccess, setWrapperRef }
}
